/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'close-thin': {
    width: 17,
    height: 18,
    viewBox: '0 0 17 18',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M8.5 8.293L16.146.646l.708.708L9.207 9l7.647 7.646-.707.708L8.5 9.707.854 17.354l-.708-.707L7.793 9 .146 1.354.854.646 8.5 8.293z" _fill="#000"/>'
  }
})
